/**
 * Transforma uma string html em uma lista de tags (Nodes)
 */
const parse = (html) => {
  const wrap = document.createElement('div');
  wrap.innerHTML = html;
  return Array.from(wrap.childNodes);
};

/**
 * Adiciona um callback para ser executado após o carregamento de uma tag
 */
const addCallback = (tag, callback) => {
  if (callback) {
    if (tag.addEventListener) {
      // eslint-disable-next-line no-param-reassign
      tag.onload = callback;
    } else {
      // eslint-disable-next-line no-param-reassign
      tag.onreadystatechange = () => {
        if (['loaded', 'complete'].includes(tag.readyState)) {
          // eslint-disable-next-line no-param-reassign
          tag.onreadystatechange = null;
          callback();
        }
      };
    }
  }
};

/**
 * Função recursiva para inserir uma tag após a outra, aguardando o carregamento individual
 */
const injectFn = (where, tags) => {
  return () => {
    try {
      if (tags.length === 0) {
        return;
      }

      const tag = tags.shift(); // separa primeira tag da lista
      const next = injectFn(where, tags);

      if (tag.nodeName === 'SCRIPT') {
        const script = document.createElement('script');
        script.async = false;
        script.type = 'text/javascript';
        script.id = tag.id;
        script.text = tag.text || tag.textContent || tag.innerHTML || '';

        const { src } = tag;

        if (src) {
          script.src = src;
          addCallback(script, next);
        }

        where.appendChild(script);

        if (!src) {
          next();
        }
      } else {
        where.appendChild(tag);
        next();
      }
    } catch (err) {
      console.warn(err);
    }
  };
};

/**
 * Insere uma string HTML num ponto específico da página, de forma que scripts rodem corretamente.
 * @param {HTMLElement} where Elemento onde devem ser inserido o HTML
 * @param {String} html String de HTML à ser inserido
 */
const injectHTML = (where, html) => {
  const tags = parse(html);
  // eslint-disable-next-line no-param-reassign
  where.innerHTML = '';
  injectFn(where, tags)();
};

export default injectHTML;
